import { get, post } from "./api"

export const searchResultsPreview = (term: string) => {
  return get("/search/autocomplete_wine_searchable_name", { term })
}

export const getAutoCompleteResults = (term: string) => {
  return get(`/api/v2/search_autocomplete?text=${term}`)
}

export const searchResults = (request: any) => {
  return get("/api/v1/wines", request)
}

export const baseWineSearch = (request: any, cookie?: string) => {
  return get("/api/v2/base_wine", request, undefined, cookie)
}

export const wineVintageSearch = (request: any, cookie?: string) => {
  return get("/api/v2/wine_vintages", request, undefined, cookie)
}

export const producerSearch = (request: any, cookie?: string) => {
  return get("/api/v2/producer", request, undefined, cookie)
}

export const getWines = (request: any, cookie?: string) => {
  return get("/api/v2/wines", request, undefined, cookie)
}

export const getBaseWine = (slug: string, id?: string, wineId?: number, cookie?: string) => {
  return get("/api/v2/base_wine/" + slug, { ...(id && { id }), ...(wineId && { wine_id: wineId }) }, undefined, cookie)
}

export const getLivexPriceHistory = (lwin11: string, currency?: string) => {
  return get(`/api/v2/wine/${lwin11}/livex_price_history?currency=${currency}`);
};

export const getWineSearcher = (wine_id: number) => {
  return get("/api/v1/wines/searcher", { wine_id })
}

export const getProducer = (slug: string, cookie?: string) => {
  return get("/api/v2/producers/" + slug, null, undefined, cookie)
}

export const getVinousFavorites = (request?: { page?: number, per_page?: number }, cookie?: string) => {
  return get("/api/v2/house_favorites/", request, undefined, cookie)
}

export const getBasewineFromWineSlug = (slug: string) => {
  return get("/api/v2/basewine_from_wine_slug", { slug })
}

export const getImporter = (slug: string) => {
  return get("/api/v2/importers/" + slug)
}

export const getWinesDetails = (winesIds: number[]) => {
  return post("/api/v2/wine", { ids: winesIds })
}
